import {
    createSelector,
} from '@reduxjs/toolkit';

import {
    selectUserSelectionById,
    selectUserSelections,
    selectSinglesStake,
} from './userSelectionsSelectors';

import {
    selectSelectionDetailsById,
    selectSelectionDetails,
} from './selectionDetailsSelectors';

import {
    selectFreebetById,
} from './freeBetSelectors';

import {
    calculateSingleBetPayout,
    calculateSinglesTabAllSinglesPayout,
} from '~Betslip/utils/payoutCalculators';

export const selectSinglePayout = createSelector(
    [
        selectSelectionDetailsById,
        selectUserSelectionById,
        selectFreebetById,
    ],
    (selectionDetails, userSelection, freebet) => {
        return calculateSingleBetPayout(selectionDetails, userSelection, Number(freebet?.value));
    }
);

export const selectAllSinglesPayout = createSelector(
    [
        selectSinglesStake,
        selectSelectionDetails,
        selectUserSelections,
    ],
    (singlesStake, selectionDetails, userSelections) => {
        let payout = 0;
        if (singlesStake > 0) {
            payout = calculateSinglesTabAllSinglesPayout(userSelections, selectionDetails);
        }

        return payout;
    }
);
